import { useMutation, useQueryClient } from "@tanstack/react-query";

import {
	type UpdateTemplateItemInput,
	updateTemplateItem,
} from "@/adapters/api";

export function useUpdateTemplateItem(templateId: string | undefined) {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: ({
			itemId,
			input,
		}: {
			itemId: string;
			input: UpdateTemplateItemInput;
		}) => {
			if (!templateId) throw new Error("missing template");
			return updateTemplateItem(templateId, itemId, input);
		},
		onSuccess: () => {
			queryClient.invalidateQueries({
				queryKey: ["stage-template", templateId],
			});
		},
	});
}
